module.exports = __webpack_public_path__ + "img/hero-login.5b030ab4.svg";